<div class="dropdown-contents">
    <p class="mb-1" *ngIf="dropDown">
        <strong>{{dropDown?.description}}</strong>
        <small *ngIf="dropDown?.presentationTypeId == 2">
            <div class="badge badge-info mr-2">Key</div>
        </small>
        <small role="button" class="text-info" (click)="onRemoveClicked()">(Remove)</small>
    </p>
    <div *ngIf="dropDown?.presentationTypeId == 2" class="form-group">
        <ul class="list-group">
            <li *ngFor="let item of dropDown.items" class="list-group-item"><span class="mapkey__key" [ngStyle]="{'background': item.colour}"></span>{{item.text}}</li>
        </ul>
    </div>

    <ng-select *ngIf="dropDown?.presentationTypeId == 1" class="mt-3"
               #ngSelectComponent
               [allowClear]="true"
               [items]="dropdownItems"
               [showDefaultOption]="true"
               (selected)="onDropDownItemSelected($event)"
               [active]="getActiveSelection()"
               placeholder="No item selected">
    </ng-select>
</div>
<div class="dropzone">
    <div class="text-center p-3" *ngIf="(selectedDropDownItem && !selectedDropDownItem.childDropDown) || !dropDownHieararchy.dropDownId">
       <span dropdown class="d-inline-block" container="body">
          <span href dropdownToggle (click)="false" class="add-button" role="button">
            <i class="fa fa-plus"></i>
            <strong clsas="ml-2">Add a dropdown</strong>
          </span>
          <ul *dropdownMenu class="dropdown-menu" role="menu">
                 <li *ngFor="let availableDropDown of availableDropDowns">
                    <span class="dropdown-item" role="button" (click)="onAvaliableDropdownSelected(availableDropDown)">
                        {{availableDropDown.label}} - ({{availableDropDown.description}})
                        <span *ngIf="availableDropDown?.presentationTypeId == 2" class="badge badge-info ml-2">Key</span>
                    </span>
                </li>
            </ul>
        </span>
    </div>
</div>
<div *ngIf="selectedDropDownItem && selectedDropDownItem.childDropDown">
    <small class="text-muted d-block text-center mt-3 mb-3">
        <i class="fa fa-long-arrow-down text-info mr-2"></i>
        Selecting <strong>{{selectedItem.text}}</strong> will display the <strong>{{getDropDownById(selectedDropDownItem.childDropDown.dropDownId).label}}</strong> dropdown
    </small>
    <dropdownhierarchyitem #childDropdownComponent
                          [(dropDownHieararchy)]="selectedDropDownItem.childDropDown" 
                          [(parentDropDownItem)]="selectedDropDownItem" 
                          [availableDropDowns]="availableDropDowns">
    </dropdownhierarchyitem>
</div>


